import { makeAutoObservable } from "mobx";
import http from "../../services/http";

export default class AdminClientStore {
  item?: IOwner;
  state: "None" | "Note" = "None";
  isLoading = false;

  async findOne(id?: string) {
    const result = await http.get(`/owners/${id}`);
    this.item = result.data.data;
  }

  async updateNote(values: any, id?: string) {
    this.isLoading = true;
    try {
      await http.put(`/licenses/owners/${id}/note`, values);
      this.state = "None";
    } catch (e) {
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

interface IOwner {
  id: string;
  email: string;
  profile: IProfile;
  activeLicenseId: string;
  licenses: ILicense[];
  promocodes: [];
  coupon?: string;
  createdAt: Date;
  note?: string;
}

interface ILicense {
  id: string;
  tariff: ITariff;
  limits: ILimit[];
  startsAt: Date;
  expiresAt: Date;
  createdAt: Date;
  description: string;
}

interface ITariff {
  id: string;
  name: string;
  systemIdentifier: null;
  limits: ILimit[];
  policies: IPolicy[];
  createdAt: Date;
}

interface IProfile {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  avatar: string;
  signature: string;
}

interface ILimit {
  id: string;
  key: {
    value: string;
    title: string;
  };
  value: number;
  createdAt: Date;
}

interface IPolicy {
  id: string;
  name: string;
  value: number;
  description: string;
  routes: IRoute[];
}

interface IRoute {
  id: string;
  name: string;
  url: string;
}
